import React from "react";
import { CheckboxProps } from "../Checkbox.types.js";

export const CheckedIcon = (props: React.HTMLAttributes<SVGElement> & { size: NonNullable<CheckboxProps["size"]> }) => {
    const { size, ...attributes } = props;

    const sizeMap: Record<NonNullable<CheckboxProps["size"]>, string> = {
        medium: "90%",
        large: "70%",
    };

    return (
        <svg
            {...attributes}
            style={{ width: sizeMap[size], height: sizeMap[size] }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            width="10px"
            height="10px"
        >
            <path fill="none" stroke="currentColor" strokeWidth="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" />
        </svg>
    );
};
